export default function cxx(...args) {
    return args.filter(Boolean).join(" ");
}
